import type { FC } from 'react';
import { Stack, Typography } from '@mui/material';

interface HRQSOpenCommentBarSegmentProps {
  percentage: number;
  backgroundColor: string;
  borderColor: string;
  color: string;
  absoluteValue: number;
  handleClick: () => void;
}

const HRQSOpenCommentBarSegment: FC<HRQSOpenCommentBarSegmentProps> = ({
  backgroundColor,
  borderColor,
  percentage,
  color,
  absoluteValue,
  handleClick,
}) => (
  <Stack
    onClick={handleClick}
    sx={[
      {
        alignItems: 'flex-end',
        justifyContent: 'center',
        p: 0.5,
        pt: 0.5,
      },
      {
        // Make sure every bar segment is wide enough for its label
        width: `${percentage}%`,
        backgroundColor,
        borderBottomWidth: '4px',
        borderBottomStyle: 'solid',
        borderBottomColor: borderColor,
        color,
        textAlign: 'end',
        cursor: 'pointer',
      },
      percentage ? { display: 'flex' } : { display: 'none' },
    ]}
  >
    {percentage > 4 && (
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {absoluteValue}
      </Typography>
    )}
  </Stack>
);

export default HRQSOpenCommentBarSegment;
